import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {DepotModel} from "../../../depots/angular/models/depot.model";
import {SelfPickupsService} from "../../services/self-pickups-service.service";
import {SelfPickupsDialogService} from "../../services/self-pickups-dialog.service";
import {ServicesFacadeService} from "../../../deliveries/angular/services/services-facade.service";
import {Service} from "../../../deliveries/models/service.model";
import {DeliveriesRequestsService} from "../../../deliveries/services/deliveries-requests.service";
import {Subscription} from "rxjs";
import * as _ from "lodash";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {ServicesService} from "../../../deliveries/services/services-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";

// POC view for the Israel Post self-pickup store flow
export class IsraelPostViewCtrl implements IController {

  depot: DepotModel;

  driversOnTheWay: number;
  quickActions: any[];
  shipments: any[];
  allShipments: any[];

  selected: any;
  statusOptions: any;

  services: Service[];
  isLoadingServices: boolean;
  isInitializedServices: boolean;
  selectedIds: string[] = [];
  previewService: Service;
  selectedService: Service;
  columns: any;
  sortType: any = {};
  group: string = 'Started';
  totals: any = {};
  totalsLoading: boolean;
  selfPickupTotals: any = {};
  isPanelOpen: boolean = true;

  public taskStatusTypes: typeof TaskStatusType = TaskStatusType;


  private selectedStatuses: any;
  private selfPickupsRef: any;
  private servicesSubscription: Subscription;
  private isLoadingServicesSubscription: Subscription;
  private isInitializedServicesSubscription: Subscription;

  /* @ngInject */
  constructor(private $state, private $selfPickups, private selfPickupsConstants,
              private servicesService: ServicesService, private omsService: OmsService,
              private selfPickupsService: SelfPickupsService, private selfPickupsDialogService: SelfPickupsDialogService,
              private servicesFacadeService: ServicesFacadeService, private deliveriesAlertsService: DeliveriesAlertsService,
              private deliveriesRequestsService: DeliveriesRequestsService, private taskRequests, private moment, private $timeout: ITimeoutService) {
  }

  $onInit() {
    this.quickActions = [
      {key: 'ScanReceive', title: 'סרוק חבילות מהנהג', icon: 'download', color: 'green-103'},
      {key: 'ScanReturn', title: 'סרוק החזרות לנהג', icon: 'upload', color: 'red-104'},
      {key: 'PrintDeliveryReport', title: 'הדפס דוח מסירה', icon: 'print-outline', color: 'gray-102'}
    ];
    this.statusOptions = _.concat(this.selfPickupsConstants.activeStatuses, ['Active']);
    this.selectedStatuses = this.statusOptions;

    this.columns = {
      agent: true,
      // progress: true,
      // contact: true,
      eta: true
    };

    this.servicesSubscription = this.servicesFacadeService.selectInfiniteScrollEntities().subscribe((services) => {
      this.services = angular.copy(services);


      if (services[0] && this.group === 'Started') {
        this.previewService = services[0];
        this.driversOnTheWay = _.uniq(_.compact(_.map(services, 'agent.id'))).length;
      }

    });
    this.isLoadingServicesSubscription = this.servicesFacadeService.selectIsLoading().subscribe((isLoading) => {
      this.isLoadingServices = isLoading;
    });
    this.isInitializedServicesSubscription = this.servicesFacadeService.selectInitialized().subscribe((initialized) => {
      this.isInitializedServices = initialized;
    });

    this._fetchShipments();
    this._fetchServices();
    this._loadServicesTotals();
    this._getSelfPickupTotals();
  }

  $onDestroy() {
    this.servicesSubscription?.unsubscribe();
    this.isLoadingServicesSubscription?.unsubscribe();
    this.isInitializedServicesSubscription?.unsubscribe();
  }

  getNow() {
    return this.moment().valueOf();
  }

  getEtaMinutes(service) {
    const eta = _.get(service, 'taskList[1].analysis.eta');
    if (!eta) {
      return 0;
    }
    return Math.max(0, Math.round((eta - this.getNow())));
  }

  onTogglePanel() {
    this.isPanelOpen = !this.isPanelOpen;
  }

  showServiceAction(action, service) {
    if (action.key === 'ScanReceive') {
      return !_.find(this.shipments, (s) => {
        return s.syncId === service.id && (s.status !== 'Completed' && s.status !== 'Canceled');
      })
    }
    if (action.key === 'ScanReturn') {
      return _.find(this.shipments, (s) => {
        return s.syncId === service.id && (s.status !== 'Completed' && s.status !== 'Canceled');
      })
    }
    return true;
  }

  onQuickAction(action, service: Service, event?) {
    if (action.key === 'PrintDeliveryReport') {
      this.servicesService.onPrint([service.id], 'Dropoff');
    }

    if (action.key === 'ScanReturn' || action.key === 'ScanReceive') {
      const packageList = _.get(service, 'packageList[0]');

      this.selfPickupsDialogService.scanPackages(packageList, event)
        .then(() => {
          this._executeQuickAction(action, service);
        })
        .catch(() => {});
    }
  }

  canApproveArrival(service: Service): boolean {
    return !!_.find(this.shipments, (s) => {
      return s.syncId === service.id && (s.status !== 'Completed' && s.status !== 'Canceled' && s.status !== 'Arrived');
    })

    // ng-if="$ctrl.selectedService.taskList[1].status === 'CourierHeading'"
  }

  private _executeQuickAction(action, service: Service) {
    if (action.key === 'ScanReturn') {
      const selfPickupToReturn = _.find(this.shipments, (s) => {
        return s.syncId === service.id;
      })

      if (!!selfPickupToReturn) {
        this.onChangeShipmentStatus(selfPickupToReturn, 'Canceled');
      }
    }
    if (action.key === 'ScanReceive') {
      const contact = service.taskList[1].taskSpec.contact?.businessName ? service.taskList[1].taskSpec.contact : service.taskList[0].taskSpec.contact;

      if (!contact.businessName) {
        contact.businessName = "דוד כהן";
      }

      const selfPickup = {
        accountId: service.account.id,
        depotId: this.depot.id,
        status: 'Ready',
        type: 'InStore', // InStore | Curbside
        notBefore: service.notBefore,
        notAfter: service.notAfter,
        syncId: service.id,
        comments: undefined,
        contact: contact,
        packages: service.packageList[0].items
      }
      this.selfPickupsService.createOne(selfPickup)
        .then((createdSelfPickup) => {
          this.allShipments = _.concat(this.allShipments, [createdSelfPickup]);
          this.onChangeShipmentStatus(createdSelfPickup, 'Ready', true);

          this._applyStatusFilter();
          this._getSelfPickupTotals();
        })
    }
  }

  onChangeQueryStatus(status) {
    this.selected = status;
    this.selectedStatuses = status ? [status] : this.statusOptions;
    this._applyStatusFilter();
  }

  onChangeShipmentStatus(shipment, status, ignoreToast?: boolean) {
    const shipmentCopy = angular.copy(shipment);
    shipmentCopy.status = status;
    this._updateShipment(shipmentCopy, ignoreToast);
  }

  onChangeShipmentStatusByService(service: Service, status) {
    const shipment = _.find(this.shipments, (s) => {
      return s.syncId === service.id;
    })

    if (!!shipment) {
      this.onChangeShipmentStatus(shipment, status);
    }
  }

  onDepotSelect(depot) {
    if (depot?.id !== this.depot.id) {
      this.depot = depot;
      this.$state.go('.', {depotId: _.get(depot, 'id')}, {notify: false, reload: false, location: 'replace'});
      this._fetchShipments();
      this._fetchServices();
      this._loadServicesTotals();
      this._getSelfPickupTotals();
    }
  }

  onChangeGroup(group) {
    this.group = this.group === group ? undefined : group;
    this._fetchServices();
    this._loadServicesTotals();
  }

  onTaskChangeStatus(task, status, event) {
    if (status === this.taskStatusTypes.Canceled) {
      // this._openCancelReason(event)
    } else {
      this.taskRequests.changeTaskStatus(status, task)
        .then((tasks) => {
          this.selectedService.taskList[1] = tasks[0];
          this.deliveriesAlertsService.changeTaskStatusSuccess(tasks[0]);
        })
        .catch((error) => {
          this.deliveriesAlertsService.changeTaskStatusError(error);
        })
        .finally(() => {

        })
    }
  }

  onSelectedIdsChange(selectedIds: string[]) {
    const newlySelectedId = _.last(selectedIds);
    this.selectedService = newlySelectedId ? angular.copy(_.find(this.services, (s) => {
      return newlySelectedId === s.id;
    })) : undefined;

    this.$timeout(() => {}, 0);
  }

  onBackToServicesList() {
    this.selectedService = undefined;
    this.selectedIds = [];

    this._fetchServices();
    this._loadServicesTotals();
  }

  private _fetchShipments() {
    const {dateStart, dateEnd} = this._getTodayRange();

    this.selfPickupsRef = this.$selfPickups();
    this.selfPickupsRef.$getAll({
      depotId: _.get(this.depot, 'id'),
      from: dateStart,
      to: dateEnd,
      limit: 1000
    })
      .then((ids) => this.selfPickupsRef.$asyncValues(ids))
      .then((selfPickups) => {
        this.allShipments = selfPickups;
        this._applyStatusFilter();
      });
  }

  private _applyStatusFilter() {
    const statuses = _.includes(this.selectedStatuses, 'Active')
      ? this.selfPickupsConstants.activeStatuses
      : this.selectedStatuses;

    this.shipments = angular.copy(_.filter(this.allShipments, (shipment) => {
      return _.includes(statuses, shipment.status);
    }));
  }

  private _fetchServices() {
    const {dateStart, dateEnd} = this._getTodayRange();

    this.servicesFacadeService.clearStore();
    this.servicesFacadeService.getInfiniteScrollEntities({
      depotIds: _.get(this.depot, 'id') ? [this.depot.id] : undefined,
      from: dateStart,
      to: dateEnd,
      group: this.group,
      limit: 300
    }, true);
  }

  private _loadServicesTotals() {
    const {dateStart, dateEnd} = this._getTodayRange();
    const depotIds = _.get(this.depot, 'id') ? [this.depot.id] : undefined;

    this.totalsLoading = true;
    this.deliveriesRequestsService.getTotals(dateStart, dateEnd, undefined, undefined, depotIds)
      .then((totals) => {
        this.totals = totals;
      })
      .finally(() => {
        this.totalsLoading = false;
      });
  }

  private _getTodayRange() {
    return {
      dateStart: this.moment().startOf('day').valueOf(),
      dateEnd: this.moment().endOf('day').valueOf()
    };
  }

  private _updateShipment(shipment, ignoreToast?: boolean) {
    this.selfPickupsService.updateOne(shipment.id, shipment, ignoreToast)
      .then((updatedShipment: any) => {
        const index = _.findIndex(this.allShipments, {id: updatedShipment.id});
        if (index > -1) {
          this.allShipments[index] = updatedShipment;
        }
        this._applyStatusFilter();
        this._getSelfPickupTotals();
      });
  }

  private _getSelfPickupTotals() {
    this.selfPickupsService.getTotals(this.depot.id, this.moment().startOf('day').valueOf(), this.moment().endOf('day').valueOf())
      .then((totals: any) => {
        this.selfPickupTotals = _.reduce(this.selfPickupsConstants.allStatuses, (map, status) => {
          map[status] = 0;
          return map;
        }, {});

        _.forEach(totals, (total) => {
          this.selfPickupTotals[total.status] = total.count;
        });
      });
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('israelPostView', {
    template: require('./israel-post-view.html').default,
    bindings: {
      depot: '<'
    },
    controller: IsraelPostViewCtrl
  });
